import React from 'react';
import { Avatar } from 'antd';
import { UserOutlined } from '@ant-design/icons';
import type { ColumnsType } from 'antd/es/table';
import { ReceptionistAiRowDisplay, getReceptionistAiStatusModifier } from './types/ReceptionistAiDisplay';

export const getReceptionistAiColumns = (): ColumnsType<ReceptionistAiRowDisplay> => [
  {
    title: 'Utilisateur',
    dataIndex: 'userName',
    key: 'user',
    render: (_, record) => (
      <div className="receptionist-ai-page__user-cell">
        {record.userAvatar ? (
          <img src={record.userAvatar} alt={record.userName} className="receptionist-ai-page__user-avatar" />
        ) : (
          <Avatar icon={<UserOutlined />} className="receptionist-ai-page__user-avatar" />
        )}
        <div className="receptionist-ai-page__user-info">
          <span className="receptionist-ai-page__user-name">{record.userName}</span>
          {record.userEmail && <span className="receptionist-ai-page__user-email">{record.userEmail}</span>}
        </div>
      </div>
    ),
  },
  {
    title: 'Activité',
    dataIndex: 'activitiesCount',
    key: 'activities',
    render: (count: number) => `${count} activité${count > 1 ? 's' : ''}`,
  },
  {
    title: 'Ce que fait Donna',
    dataIndex: 'motifsSummary',
    key: 'motifs',
  },
  {
    title: 'Appels captés ce mois',
    dataIndex: 'callsThisMonth',
    key: 'callsThisMonth',
  },
  {
    title: 'Statut',
    dataIndex: 'status',
    key: 'status',
    render: (status: ReceptionistAiRowDisplay['status']) => (
      <span
        className={`receptionist-ai-page__status-badge receptionist-ai-page__status-badge--${getReceptionistAiStatusModifier(status)}`}
      >
        {status}
      </span>
    ),
  },
];
